import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSimulateBetterDocSecondOpinionVisitConfirmationMutation as useSimulateBetterDocSecondOpinionVisitConfirmationMutationType } from "@/modules/admin/better-doc/services/__generated__/useSimulateBetterDocSecondOpinionVisitConfirmationMutation.graphql"

const mutation = graphql`
  mutation useSimulateBetterDocSecondOpinionVisitConfirmationMutation(
    $input: De_simulateBetterDocSecondOpinionVisitConfirmationInput!
  ) {
    de_simulateBetterDocSecondOpinionVisitConfirmation(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useSimulateBetterDocSecondOpinionVisitConfirmationMutation = () => {
  return useBetterDocMutation<useSimulateBetterDocSecondOpinionVisitConfirmationMutationType>(mutation)
}
